// extracted by mini-css-extract-plugin
export default {"hamburger":"Hamburger_hamburger__Xpbbd","navItem":"Hamburger_navItem__bNh6+","onHover":"Hamburger_onHover__ooOlp","icon":"Hamburger_icon__r0y9p"};